const Check = () => (
    <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 12.5C0 5.59644 5.59644 0 12.5 0V0C19.4036 0 25 5.59644 25 12.5V12.5C25 19.4036 19.4036 25 12.5 25V25C5.59644 25 0 19.4036 0 12.5V12.5Z"
            fill="#0063FB"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.3231 6.94865C20.8002 7.38599 20.8324 8.12728 20.3951 8.60437L11.8014 17.9794C11.5854 18.215 11.2825 18.3522 10.963 18.3591C10.6434 18.366 10.3349 18.2422 10.1089 18.0161L5.42136 13.3286C4.96371 12.871 4.96371 12.129 5.42136 11.6714C5.879 11.2137 6.621 11.2137 7.07864 11.6714L10.9007 15.4934L18.6674 7.02064C19.1047 6.54355 19.846 6.51132 20.3231 6.94865Z"
            fill="white"
        />
    </svg>
);

export default Check;
